import CircularProgress from '@mui/material/CircularProgress'

export const GradientProgress = ({ size = 40, thickness = 3, ...rest }) => (
  <>
    <svg width={0} height={0}>
      <defs>
        <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#01173c" />
          <stop offset="100%" stopColor="#31d1d3" />
        </linearGradient>
      </defs>
    </svg>
    <CircularProgress
      size={size}
      thickness={thickness}
      sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }}
      {...rest}
    />
  </>
)
